"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.City = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const state_entity_1 = require("./state.entity");
let City = class City {
    constructor(name, state) {
        this.name = name;
        this.state = state;
    }
};
exports.City = City;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Object)
], City.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "name", type: "varchar", length: 100 }),
    tslib_1.__metadata("design:type", String)
], City.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => state_entity_1.State, (state) => state.id),
    (0, typeorm_1.JoinColumn)({ name: "state_id" }) // Ensure the correct column name is used
    ,
    tslib_1.__metadata("design:type", typeof (_b = typeof state_entity_1.State !== "undefined" && state_entity_1.State) === "function" ? _b : Object)
], City.prototype, "state", void 0);
exports.City = City = tslib_1.__decorate([
    (0, typeorm_1.Entity)("city"),
    tslib_1.__metadata("design:paramtypes", [String, typeof (_a = typeof state_entity_1.State !== "undefined" && state_entity_1.State) === "function" ? _a : Object])
], City);
